import React, { useState } from 'react';
import './FakeEventWarning.css';

const FakeEventWarning = ({ onAccept, onCancel, language = 'ru' }) => {
  const [understood, setUnderstood] = useState(false);

  const translations = {
    kk: {
      title: "Жауапкершілік туралы ескерту",
      warning: "НАЗАР АУДАРЫҢЫЗ! Жалған немесе дұрыс емес ақпарат беру заңмен жауапкершілікке алып келеді.",
      responsibility: "Сіз мынаған жауапты боласыз:",
      points: [
        "Жасанды және жалған оқиғалар жасамау",
        "Нақты ақпарат беру",
        "Қала қызметтерінің уақытын дұрыс пайдалану",
        "Заңды салдарлар үшін жеке жауапкершілік"
      ],
      punishment: "Жалған ақпарат беру үшін әкімшілік немесе қылмыстық жауапкершілік көзделуі мүмкін.",
      confirmation: "Мен ескертуді оқып, түсіндім және жауапкершілікті қабылдаймын",
      accept: "Қабылдау",
      cancel: "Болдырмау"
    },
    ru: {
      title: "Предупреждение об ответственности",
      warning: "ВНИМАНИЕ! Предоставление ложной или недостоверной информации влечет ответственность согласно законодательству.",
      responsibility: "Вы несете ответственность за:",
      points: [
        "Недопущение создания искусственных и ложных событий",
        "Предоставление достоверной информации",
        "Рациональное использование времени городских служб",
        "Личную ответственность за правовые последствия"
      ],
      punishment: "За предоставление ложной информации может быть предусмотрена административная или уголовная ответственность.",
      confirmation: "Я прочитал и понял предупреждение и принимаю на себя ответственность",
      accept: "Принимаю",
      cancel: "Отмена"
    }
  };

  const t = translations[language] || translations.ru;

  return (
    <div className="fake-warning-overlay">
      <div className="fake-warning-modal">
        <div className="fake-warning-header">
          <h3>{t.title}</h3>
        </div>
        
        <div className="fake-warning-content">
          <div className="warning-alert">
            ⚠️ {t.warning}
          </div>
          
          <div className="responsibility-section">
            <h4>{t.responsibility}</h4>
            <ul className="responsibility-list">
              {t.points.map((point, index) => (
                <li key={`responsibility-point-${index}`}>{point}</li>
              ))}
            </ul>
          </div>
          
          <div className="punishment-notice">
            <strong>📋 {t.punishment}</strong>
          </div>
          
          <div className="confirmation-section">
            <label className="confirmation-checkbox">
              <input
                type="checkbox"
                checked={understood}
                onChange={(e) => setUnderstood(e.target.checked)}
              />
              <span className="checkbox-text">{t.confirmation}</span>
            </label>
          </div>
        </div>
        
        <div className="fake-warning-actions">
          <button
            className="cancel-btn"
            onClick={onCancel}
          >
            {t.cancel}
          </button>
          <button
            className="accept-btn"
            onClick={onAccept}
            disabled={!understood}
          >
            {t.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FakeEventWarning;